import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';

/**
 * Wraps a single list item and reports its rendered height via ResizeObserver.
 * FIX: now also tracks previous height to avoid scroll jump
 */
const MeasureWrapper = ({ index, measureItem, children }) => {
   const ref = useRef(null);
   const prevHeightRef = useRef(0); // ✅ NEW

   useEffect(() => {
      const element = ref.current;
      if (!element) return;

      const observer = new ResizeObserver(entries => {
         const height = entries[0].borderBoxSize?.[0]?.blockSize ?? entries[0].contentRect.height;

         if (height <= 0) return;

         const prevHeight = prevHeightRef.current;

         if (prevHeight !== height) {
            measureItem(index, height, prevHeight); // ✅ send delta info
            prevHeightRef.current = height;
         }
      });

      observer.observe(element);
      return () => observer.disconnect();
   }, [index, measureItem]);

   return <div ref={ref}>{children}</div>;
};

MeasureWrapper.propTypes = {
   index: PropTypes.number.isRequired,
   measureItem: PropTypes.func.isRequired,
   children: PropTypes.node,
};

export default MeasureWrapper;
